import * as React from 'react';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState, AppThunkDispatch } from '../../store';
import { ClientOrderEntity } from '../../store/entities/state';
import { createEntity, entityCreatingCancel, updateEntity } from '../../store/entities/actions';
import { createClientOrderAsync, updateClientOrderAsync } from '../../ajax/requests';
import { ClientOrder } from '../../models';
import ClientOrderForm from './ClientOrderForm';

const ClientOrderEditForm: FC = () => {
    const dispatch = useDispatch<AppThunkDispatch>();
    const changing = useSelector((state: ApplicationState) => state.entities.orders?.changing);

    if (!changing) return null;

    const order = changing.value as ClientOrderEntity;
    const isCreating = changing.action === 'creating';

    const handleSave = async (savedOrder: ClientOrder) => {
        if (isCreating) {
            await dispatch(createEntity(
                'orders',
                savedOrder as ClientOrderEntity,
                async () => createClientOrderAsync(savedOrder),
            ));
        } else {
            await dispatch(updateEntity(
                'orders',
                savedOrder as ClientOrderEntity,
                async () => { await updateClientOrderAsync(savedOrder); },
            ));
        }
    };

    const handleClose = () => {
        dispatch(entityCreatingCancel('orders'));
    };

    return (
        <ClientOrderForm
            defaultValue={order}
            onSave={handleSave}
            onClose={handleClose}
        />
    );
};

export default ClientOrderEditForm;
